




































































































































































import ModalMixin from '@/mixins/modal.mixin';
import { compass } from '@resclick/compass';
import { i18n } from '@/i18n';
import { CrsForm } from '@resclick/crs-ui';
import { Component, Mixins, Watch } from 'vue-property-decorator';

@Component
export default class UserRoleModal extends Mixins(ModalMixin) {
  suppliersOptions: any[] = [];
  buyersOptions: any[] = [];
  propertiesOptions: any[] = [];
  propertyGroupOptions: any[] = [];
  countriesOptions: any[] = [];
  currencies: any[] = [];
  marketsOptions: any[] = [];

  get marginTypeOptions() {
    return [
      {
        label: i18n.t('GENERAL.MARKUP'),
        value: 'MARKUP',
      },
      {
        label: i18n.t('GENERAL.COMMISSION'),
        value: 'COMMISSION',
      },
    ];
  }

  get applicationTypeOptions() {
    return [
      {
        label: i18n.t('GENERAL.PER_PERSON_PER_NIGHT'),
        value: 'PER_PERSON_NIGHT',
      },
      {
        label: i18n.t('GENERAL.PER_ROOM_PER_NIGHT'),
        value: 'PER_ROOM_NIGHT',
      },
      {
        label: i18n.t('GENERAL.PER_ROOM_FIX'),
        value: 'PER_ROOM_FIX',
      },
      {
        label: i18n.t('GENERAL.PER_CHILD_PER_NIGHT'),
        value: 'PER_CHILD_NIGHT',
      },
    ];
  }

  get unitOptions() {
    return [{ label: 'Percent (%)', value: 'PERCENT' }, ...this.currencies];
  }

  form!: CrsForm<'companyMargins', 'create' | 'update'>;

  @Watch('mode', { immediate: true })
  switchForm(mode: 'create' | 'update') {
    this.form = this.$crsForm('companyMargins', mode, {
      name: '',
      markets: [],
      countries: [],
      suppliers: [],
      buyers: [],
      properties: [],
      propertyGroups: [],
      roomTypes: [],
      bookingStartDate: new Date(),
      bookingEndDate: new Date(),
      minCheckInDate: new Date(),
      maxCheckInDate: new Date(),
      applicationType: 'PER_ROOM_NIGHT',
      type: 'MARKUP',
      unit: 'PERCENT',
      value: 0,
    });
  }

  onHide(value: boolean) {
    if (!value) {
      this.openSync = false;
    } else this.openSync = true;
  }

  get bookingDateRange() {
    return {
      start: this.form.fields.bookingStartDate,
      end: this.form.fields.bookingEndDate,
    };
  }

  set bookingDateRange(value) {
    this.form.fields.bookingStartDate = value.start;
    this.form.fields.bookingEndDate = value.end;
  }

  get checkInDateRange() {
    return {
      start: this.form.fields.minCheckInDate,
      end: this.form.fields.maxCheckInDate,
    };
  }

  set checkInDateRange(value) {
    this.form.fields.minCheckInDate = value.start;
    this.form.fields.maxCheckInDate = value.end;
  }

  get formMarkets() {
    return this.form.fields.markets || [];
  }

  set formMarkets(value: string[]) {
    const oldMarkets = this.form.fields.markets || [];
    const queryMarkets = [...oldMarkets, ...value];

    compass
      .do('markets', 'find', {
        filter: { id: { $in: queryMarkets } },
        select: ['countries'],
      })
      .then((res) => {
        const markets = res.data || [];
        let newCountryList: string[] = this.form.fields.countries || [];

        let unchange: string[] = [];
        let remove: string[] = [];
        let add: string[] = [];

        for (const market of markets) {
          if (oldMarkets.includes(market.id as string)) {
            if (value.includes(market.id as string)) unchange.push(...market.countries);
            else remove.push(...market.countries);
          } else add.push(...market.countries);
        }

        unchange = [...new Set(unchange)];
        add = [...new Set(add)].filter((item) => !unchange.includes(item));
        remove = [...new Set(remove)].filter((item) => !unchange.includes(item) && !add.includes(item));

        newCountryList = newCountryList.filter((item) => !remove.includes(item));
        newCountryList.push(...add);
        this.form.fields.countries = [...new Set(newCountryList)];
      });

    this.form.fields.markets = value;
  }

  get formPropertyGroups() {
    return this.form.fields.propertyGroups || [];
  }

  set formPropertyGroups(value: string[]) {
    const oldGroups = this.form.fields.propertyGroups || [];
    const queryGroups = [...oldGroups, ...value];

    compass
      .do('propertyGroups', 'find', {
        filter: { id: { $in: queryGroups } },
        select: ['properties'],
      })
      .then((res) => {
        const groups = res.data || [];
        let newGroupList: string[] = this.form.fields.properties || [];

        let unchange: string[] = [];
        let remove: string[] = [];
        let add: string[] = [];

        for (const group of groups) {
          if (oldGroups.includes(group.id as string)) {
            if (value.includes(group.id as string)) unchange.push(...group.properties);
            else remove.push(...group.properties);
          } else add.push(...group.properties);
        }

        unchange = [...new Set(unchange)];
        add = [...new Set(add)].filter((item) => !unchange.includes(item));
        remove = [...new Set(remove)].filter((item) => !unchange.includes(item) && !add.includes(item));

        newGroupList = newGroupList.filter((item) => !remove.includes(item));
        newGroupList.push(...add);
        this.form.fields.properties = [...new Set(newGroupList)];
      });

    this.form.fields.propertyGroups = value;
  }

  mounted() {
    const mapToOptions = (item: { id?: string | number; name: string }) => {
      return {
        label: item.name,
        value: item.id,
      };
    };
    this.$getCrsList('markets', 'find', {
      filter: { isActive: true },
      sort: { name: 1 },
      select: ['name'],
    }).then((res) => {
      this.marketsOptions = res.map(mapToOptions);
    });
    this.$getCrsList('properties', 'find', {
      filter: { isActive: true },
      sort: { name: 1 },
      select: ['name'],
    }).then((res) => {
      this.propertiesOptions = res.map(mapToOptions);
    });
    this.$getCrsList('propertyGroups', 'find', {
      filter: { isActive: true },
      sort: { name: 1 },
      select: ['name'],
    }).then((res) => {
      this.propertyGroupOptions = res.map(mapToOptions);
    });

    this.$getCrsList('companies', 'find', {
      filter: { isActive: true, isSupplier: true },
      sort: { name: 1 },
      select: ['name'],
    }).then((res) => {
      this.suppliersOptions = res.map(mapToOptions);
    });

    this.$getCrsList('companies', 'find', {
      filter: { isActive: true, isBuyer: true },
      sort: { name: 1 },
      select: ['name'],
    }).then((res) => {
      this.buyersOptions = res.map(mapToOptions);
    });

    this.$getCrsList('geo', 'countries', {
      sort: { name: 1 },
    }).then((res) => {
      this.countriesOptions = res.map((item) => {
        return {
          label: item.name,
          value: item.countryCode,
        };
      });
    });

    this.$getCrsList('currencies', 'find', {}).then((res) => {
      this.currencies = res.map((item) => {
        return {
          label: item.name,
          value: item.code,
        };
      });
    });
  }

  async getForm() {
    return compass.do('companyMargins', 'findOne', { params: { id: this.id } });
  }
}
